module.exports = require("core-js/modules/esnext.set.reduce.js");